export const styles = (theme) => ({
  root: ({ buttonProps: { fullWidth } }) => ({
    minWidth: fullWidth ? 'auto' : 310,
    '& > svg': {
      right: theme.spacing(1),
      position: 'absolute',
    },
    [theme.breakpoints.down('lg')]: {
      minWidth: 'auto',
      width: '100%',
    },
  }),
});
